import {useSvip} from '../../../hooks/useSvip';
import React,{useState} from 'react';
import Panel from '../../../components/Panel/Panel';
import {JButton} from '../../../components/UI/JButton';
import JPanel from '../../../components/UI/JPanel';
import {JTextField} from '../../../components/UI/JTextField';
import {useAppDispatch,useAppSelector} from '../../../hooks';
import {setSynth} from '../../../slices/bloodlineSlice';
import {toServer} from '../../../util/ServerSocket';

/** The server validates SVIP and returns inventory indexes; synthesis still needs confirmation. */
export function SVIPAutoFillButton(){
 const [denied,setDenied]=useState(false);
 const [busy,setBusy]=useState(false),[message,setMessage]=useState('คุณไม่ใช่สมาชิก SVIP ไม่สามารถใช้งานได้');
 const svip=useSvip(),selected=useAppSelector(state=>state.bloodline.synth),dispatch=useAppDispatch();
 const fill=()=>{if(!svip){setMessage('คุณไม่ใช่สมาชิก SVIP ไม่สามารถใช้งานได้');setDenied(true);return;}if(busy)return;setBusy(true);const timer=window.setTimeout(()=>{setBusy(false);setMessage('เชื่อมต่อหมดเวลา กรุณาลองใหม่');setDenied(true);},10000);toServer('svipAutoFillSouls',{selected},(reply:any)=>{window.clearTimeout(timer);setBusy(false);if(reply?.ok&&Array.isArray(reply.indexes))dispatch(setSynth(reply.indexes));else{setMessage(reply?.error||'ไม่สามารถดึงวิญญาณได้');setDenied(true);}});};
 return <>
  <JButton x={50} text="Auto Fill Souls" disabled={busy} onClick={fill}/>
  {denied&&<Panel moveable={false} onClose={()=>setDenied(false)} style={{zIndex:10000}}>
    <JPanel size={{width:280,height:110}}>
      <JTextField size={{width:260,height:70}} position={{x:10,y:10}} text={message}/>
      <JButton size={{width:75,height:25}} position={{x:102,y:80}} text="Close" onClick={()=>setDenied(false)}/>
    </JPanel>
  </Panel>}
 </>;
}
